import stores from 'bootstrap/store';
import { machineTechnicianUpsertModalRouteStore } from '../domain/upsert-modal-store';
const kiosksStore = stores.global.kiosks;

export default (kiosk) => {
  machineTechnicianUpsertModalRouteStore.deleteKiosk(kiosk);
  machineTechnicianUpsertModalRouteStore.setValue('workPlaceFilter', '');
  kiosksStore.setValue('dataForAdmin', {});
};
